export type ClientListFilter = 'active' | 'leads' | 'archived';
export type ClientTab = 'plan' | 'packages' | 'challenges' | 'more';

export const MORE_SECTION_IDS: ReadonlySet<string> = new Set([
  'client-tasks',
  'client-measurements',
  'client-notes',
  'client-credentials',
]);

export function parseClientFilter(search: string): ClientListFilter {
  const value = new URLSearchParams(search).get('filter');
  if (value === 'leads' || value === 'archived') return value;
  return 'active';
}

export function clientListContext(client: {
  nextActionNote?: string;
  email?: string;
}): string | null {
  const note = client.nextActionNote?.trim();
  if (note) return note;
  const email = client.email?.trim();
  return email || null;
}

export function clientIdFromPath(pathname: string): string | undefined {
  const match = pathname.match(/^\/clients\/([^/]+)$/);
  if (!match || match[1] === 'invite') return undefined;
  return match[1];
}

export function parseClientTab(search: string): ClientTab {
  const params = new URLSearchParams(search);
  const section = params.get('section');
  if (section === 'client-packages') return 'packages';
  if (section && MORE_SECTION_IDS.has(section)) return 'more';
  const tab = params.get('tab');
  if (tab === 'plan' || tab === 'packages' || tab === 'challenges' || tab === 'more') return tab;
  return 'plan';
}

export function nearestActiveBooking<
  T extends { clientId: string; startsAt: string; durationMinutes: number; status: string },
>(bookings: T[], clientId: string, now: Date): T | null {
  const nowMs = now.getTime();
  return (
    bookings
      .filter((booking) => booking.clientId === clientId)
      .filter((booking) => booking.status === 'PENDING' || booking.status === 'CONFIRMED')
      .filter((booking) => new Date(booking.startsAt).getTime() + booking.durationMinutes * 60_000 > nowMs)
      .sort((a, b) => new Date(a.startsAt).getTime() - new Date(b.startsAt).getTime())[0] ?? null
  );
}

export function activePackageRemaining(
  packages: Array<{ status: string; totalSessions: number; usedSessions: number }> | undefined,
): number | null {
  if (!packages) return null;
  const active = packages.find((pkg) => pkg.status === 'ACTIVE');
  if (!active) return null;
  return Math.max(0, active.totalSessions - active.usedSessions);
}
